/**
 * getUserEmailConfiguration GraphQL specification
 * @module src/graphql/getUserEmailConfiguration
 */

import gql from 'graphql-tag';

export const GET_USER_EMAIL_CONFIGURATION = gql`
  query GetUserEmailConfiguration {
    getUserEmailConfiguration {
      id
      userId
      customEmailBody
      contactDetailsInfo
      orderDetailsInfo
      repSignature
      addBillSheetAttachment
      firstName
      lastName
      title
      business
      department
      city
      phone
      emailLink
      hyperlink
      createdAt
      updatedAt
    }
  }
`;
